import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { Page, LayoutSingleColumn } from '../../components';
import { ExternalLink } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterNew from '../../components/Footer/FooterNew';

import SectionImpact from '../../components/SectionImpact/SectionImpact';





























import css from './AboutPage.module.css';
import ThisIsSocialbnb from '../OldSTLandingPage/sections/ThisIsSocialbnb/ThisIsSocialbnb';

const heroImage = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082966/socialbnb/containers/OldSTLandingPage/sections/HeroSection/assets/search-bg.webp';

const article15 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082863/socialbnb/assets/partners/SEND.png';

const article16 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082862/socialbnb/assets/partners/planetera.png';

const article17 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082862/socialbnb/assets/partners/partnerEU.png';

const article10 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082861/socialbnb/assets/partners/ImpactFactory.png';

const article14 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082857/socialbnb/assets/partners/gotoMarket.png';

const article9 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082856/socialbnb/assets/partners/GIZ.png';

const article8 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082855/socialbnb/assets/partners/Gateway.png';

const article11 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082854/socialbnb/assets/partners/far_Logo.jpg';

const article4 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082853/socialbnb/assets/partners/Enactus.webp';

const article3 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082852/socialbnb/assets/partners/ECPAT.png';

const article12 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082851/socialbnb/assets/partners/Bmwk-big-.webp';

const article13 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082851/socialbnb/assets/partners/Animondial.png';

const LoaderImage1 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082844/socialbnb/assets/loader/world.png';

const LoaderImage2 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082842/socialbnb/assets/loader/airplane.png';

const linkedIn = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082619/socialbnb/assets/icons/socialmedia/linkedIn-icon.webp';

const insta = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082618/socialbnb/assets/icons/socialmedia/instagram-icon.webp';

const fb = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082616/socialbnb/assets/icons/socialmedia/facebook-icon.webp';

const ltandc = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082356/socialbnb/assets/articles/lt_c_logo.webp';

const innovatorsPitch = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082011/socialbnb/assets/articles/article19.webp';

const article18 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082008/socialbnb/assets/articles/article17.webp';

const Traveler = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769081990/socialbnb/assets/aboutPage/traveler.png';

const Plus = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769081990/socialbnb/assets/aboutPage/plus.png';

const MrThyLines = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769081989/socialbnb/assets/aboutPage/Mr_thy_lines.png';

const MrThy = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769081988/socialbnb/assets/aboutPage/Mr_thy.png';

const Houses = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769081985/socialbnb/assets/aboutPage/houses.png';

const AboutPage = () => {
  const intl = useIntl();
  const [loadingState, setLoadingState] = useState(false);
  const [youtubeEmbedUrl, setYoutubeEmbedUrl] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setLoadingState(true);
    }, 1000);
  }, []);

  const topbarRef = React.useRef(null);

  const loader = !loadingState ? (
    <div className={css.loader}>
      <img
        src={LoaderImage2}
        alt="loaderImage"
        className={`${css.loaderImage2} ${css.rotateAnimation}`}
        width="100px"
      ></img>

      <img
        src={LoaderImage1}
        alt="loaderImage1"
        className={`${css.loaderImage1} ${css.moveAnimation}`}
        width="100px"
      ></img>
    </div>
  ) : null;

  useEffect(() => {
    if (typeof window !== 'undefined' && window?.document) {
      document?.body?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, []);

  // Build YouTube embed URL with origin parameter to fix Error 153
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const videoId = 'TEW_4hKpeFE';
      const origin = window.location.origin;
      const baseUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
      const params = new URLSearchParams({
        origin: origin,
        enablejsapi: '1',
        rel: '0',
        modestbranding: '1',
        start: '1',
      });
      setYoutubeEmbedUrl(`${baseUrl}?${params.toString()}`);
    }
  }, []);

  const whyWrapperContent = loadingState === true && (
    <div
      className={css.section}
      data-elb="section"
      data-elb-section="name:whyText;position:3"
      data-elbaction="visible"
    >
      <div className={css.whyWrapper}>
        <div className={css.whyTextWrapper}>
          <h2 id="anima" className={css.whyTextHeader}>
            <FormattedMessage id="about.whyTextblock1Header" />
          </h2>

          <p className={css.text}>
            <FormattedMessage id="about.whyTextblock1Text" />
          </p>
        </div>
        <div className={css.whyTextWrapper}>
          <div className={css.whyTextHeaderWrapper}>
            <h2 id="anima" className={`${css.whyTextHeader} ${css.whyTextBlock2Header}`}>
              <FormattedMessage id="about.whyTextblock2Header" />
            </h2>
          </div>
          <p className={css.text}>
            <FormattedMessage id="about.whyTextblock2Text" />
          </p>
        </div>
      </div>
      <div className={css.imagesWrapper}>
        <div className={`${css.imagesItemsOuter} ${css.houses}`}>
          <img src={Houses} alt="houses"></img>
        </div>
        <div className={css.imagesItemsInner}>
          <img src={Plus} alt="additional"></img>
        </div>
        <div className={`${css.imagesItemsOuter} ${css.traveller}`}>
          <img src={Traveler} alt="traveller"></img>
        </div>
      </div>
    </div>
  );
  const content = (
    <div style={{ overflow: 'hidden' }}>
      <div id="topbar" className={css.topbar} style={{ position: 'fixed', width: '100vw' }}>
        <TopbarContainer />
      </div>

      <div className={css.LeftFooterContent}>
        <ExternalLink
          href="https://www.instagram.com/socialbnb"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={insta} className={css.socialmedia} alt="instagram"></img>
        </ExternalLink>

        <ExternalLink
          href="https://www.facebook.com/Socialbnb"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={fb} className={css.socialmedia} alt="facebook"></img>
        </ExternalLink>

        <ExternalLink
          href="https://www.linkedin.com/company/socialbnb/"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={linkedIn} className={css.socialmedia} alt="facebook"></img>
        </ExternalLink>
      </div>

      <div
        className={css.section}
        data-elb="section"
        data-elb-section="name:hero;position:1"
        data-elbaction="visible"
      >
        <div
          id="heroWrapper"
          className={css.heroWrapper}
          style={{ margnTop: '0', height: '70vh', overflow: 'hidden' }}
        >
          <div className={css.HeaderWrapper}>
            <h1
              id="anima"
              className={
                loadingState === false ? css.Header1 : `${css.Header1} ${css.Header1Visible}`
              }
            >
              <FormattedMessage id="AboutPage.h1.part2" />
            </h1>

            <div
              id="anima3"
              className={
                loadingState === false
                  ? css.SubHeader1
                  : `${css.SubHeader1} ${css.SubHeader1Visible}`
              }
            >
              <h2>
                <FormattedMessage id="AboutPage.h2" />
              </h2>
            </div>
          </div>

          <img
            className={
              loadingState === false ? css.heroImage : `${css.heroImage} ${css.heroImageVisible}`
            }
            src={heroImage}
            alt="heroImage"
            width="100%"
            onLoad={() => {}}
            onError={e => {
              console.error('Error loading image:', e);
            }}
          />
        </div>
      </div>

      <div className={css.section}>
        <div className={css.storyWrapper}>
          <div className={css.storyPhotoWrapper}>
            <img src={MrThyLines} alt="mrThylines" className={css.storyPhoto1}></img>
            <img src={MrThy} className={css.storyPhoto_hide} alt=""></img>
          </div>
          <div className={css.storyTextWrapper}>
            <div
              className={css.whyTextWrapper}
              data-elb="section"
              data-elb-section="name:OurStory;position:2"
              data-elbaction="visible"
            >
              <h2 id="anima" className={css.whyTextHeader}>
                <FormattedMessage id="about.storyHeadline" />
              </h2>

              <div className={css.text}>
                <p>
                  <FormattedMessage id="about.storyTextBlock1" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={css.section}>
        <div className={css.youtubeVideoWrapper}>
          <iframe
            width="100%"
            height="100%"
            src={youtubeEmbedUrl || 'https://www.youtube-nocookie.com/embed/TEW_4hKpeFE'}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            className={css.youtubeVideo}
          ></iframe>
        </div>
      </div>

      <hr className={css.divider}></hr>

      <ThisIsSocialbnb />
      <div> {whyWrapperContent} </div>
      <hr className={css.divider}></hr>
      <SectionImpact />

      <div
        className={css.section4}
        data-elb="section"
        data-elb-section="name:partnersSection;position:9"
        data-elbaction="visible"
      >
        <div className={css.partnersWrapper}>
          <h2 id="partner" className={css.partnersHeader}>
            <FormattedMessage id="about.partnersHeadline" />
          </h2>

          <div className={css.articles}>
            <div className={css.articlesItems}>
              <ExternalLink href="https://ecpat.de/" target="_blank" style={{ height: '100%' }}>
                <img src={article3} alt="article3"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.enactus.de/uni-koeln/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article4} alt="article4"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.gateway.uni-koeln.de/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article8} alt="article8"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.giz.de/de/html/index.html"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article9} alt="article9"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://impact-factory.de/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article10} alt="article10"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://forumandersreisen.de/startseite/aktuelles/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article11} alt="article11"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.bmwk.de/Navigation/DE/Home/home.html"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article12} alt="article12"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.unwto.org/unwto-awake-tourism-challenge"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article18} alt="article18"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://animondial.com/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article13} alt="article13"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <img src={article14} alt="goToMarket"></img>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://planeterra.org/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article16} alt="article16"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <img src={article17} alt="partnerEU"></img>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.send-ev.de/"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={article15} alt="article15"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.bitkom.org/Themen/Startups/Innovators-Pitch"
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={innovatorsPitch} alt="innovatorsPitch"></img>
              </ExternalLink>
            </div>

            <div className={css.articlesItems}>
              <ExternalLink
                href="https://www.ltandc.org/ "
                target="_blank"
                style={{ height: '100%' }}
              >
                <img src={ltandc} alt="ltandc"></img>
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
      <div className={`${css.section} ${css.section5}`}></div>
    </div>
  );

  return (
    <Page
      title={intl.formatMessage({ id: 'AboutPage.title' })}
      description={intl.formatMessage({ id: 'AboutPage.desc' })}
      keywords={intl.formatMessage({ id: 'AboutPage.keywords' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: intl.formatMessage({ id: 'AboutPage.title' }),
        url: `https://socialbnb.org/${intl?.locale || 'en'}/about`,
      }}
    >
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={
          <div
            id="topbar"
            ref={topbarRef}
            style={{ position: 'fixed', width: '100vw', top: 0 }}
            data-elbglobals="pagetype:AboutUs"
            data-elbcontext="booking:aboutUs"
          >
            <TopbarContainer />
          </div>
        }
        footer={<FooterNew />}
      >
        <div className={css.Wrapper}>
          {loader} {content}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default AboutPage;
